import {TokenManager} from "../TokenManager";


export class ApiClass {
    protected jsonHeader = {
        "Content-Type": "application/json"
    }
    
    authHeader(): HeadersInit {
        const token = TokenManager.getToken();
        
        return {
            "Content-Type": "application/json",
            "Authorization": token
        }
    }
}
